export default __webpack_public_path__ + "static/media/vehelix_car.d0171d7e.svg";